module.exports = __webpack_public_path__ + "static/media/userPhoto.a789b649.svg";